import React from 'react';
import styled from 'styled-components';

import { GENDERS } from '@front/common/src/constants/accounts';
import type { Salutation } from '@front/common/src/types/commons';

import { translate } from '@front/i18n';

import Radio from '../radio/radio';
import Text from '../base-text/variants/text';
import BottomMessage from '../input/components/bottom-message';

export const GenderSelectorContainer = styled.div`
  margin-bottom: 15px;
  gap: 20px;
`;

const RadioContainer = styled.div`
  display: flex;
  gap: 20px;
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const t = translate('screens.signup.user');

type GenderSelectorProps = {
  value?: string;
  error?: string;
  onChange: (gender: Salutation) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  className?: string;
};

const GenderSelector = React.forwardRef<HTMLInputElement, GenderSelectorProps>(
  ({ value: gender, onChange, onBlur, error, className }, ref) => (
    <GenderSelectorContainer className={className}>
      <RadioContainer>
        {GENDERS.map(({ key, value }) => (
          <Label key={key}>
            <Radio
              onBlur={onBlur}
              checked={gender === value}
              id={`salutation-${value}`}
              name='salutation'
              onChange={() => onChange(value)}
              value={value}
              ref={ref}
            />
            <Text.MDMedium>{t(`salutations.${key}`)}</Text.MDMedium>
          </Label>
        ))}
      </RadioContainer>
      <BottomMessage error={error} />
    </GenderSelectorContainer>
  ),
);

export default GenderSelector;
